import axios from 'axios';

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async retrievePublisherData() {
      try {
        const response = await axios.get('/publisher', { withCredentials: true });
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    async retrievePublisherProjectsByCreatedAt(context, createdAt) {
      try {
        const response = await axios.get(`/publisher/projects/${createdAt}`, { withCredentials: true });
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    async retrievePublisherInfo(context, data) {
      try {
        const response = await axios.get('/publisher/config', data, { withCredentials: true });
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    async changePublisherStatus() {
      try {
        const response = await axios.post('/publisher', { withCredentials: true });
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    async changePublisherFrequency(context, data) {
      try {
        const response = await axios.patch('/publisher', data, { withCredentials: true });
        return response.data;
      } catch (error) {
        throw error;
      }
    },
  },
};
